export default function ProgressBar({ value, max, label, color = 'xp' }) {
  const percent = Math.min(100, Math.round((value / Math.max(max, 1)) * 100));

  const fills = {
    xp: 'bg-gradient-to-r from-xp to-blue-400',
    gold: 'bg-gradient-to-r from-gold to-gold-light',
    green: 'bg-gradient-to-r from-forest to-forest-light',
    red: 'bg-gradient-to-r from-energy to-red-400',
  };

  return (
    <div className="w-full">
      {label && (
        <div className="flex justify-between text-xs font-body mb-1">
          <span className="text-muted">{label}</span>
          <span className="text-accent font-bold">{value} / {max}</span>
        </div>
      )}
      <div className="xp-bar-track h-3">
        <div
          className={`xp-bar-fill ${fills[color]}`}
          style={{ width: `${percent}%` }}
        />
      </div>
    </div>
  );
}
